import type { Filter } from "@/components/StructuredSearch/config/types";
import { FilterValueType } from "@/components/StructuredSearch/config/structured-search-schema";
import { HistoryImportSource } from "@/routes/smart-table/utils/historyImportTypes";

const REQUEST_ID_FIELD = "pl_id";
const TRACE_ID_FIELD = "trace_id";

export const buildHistoryImportExclusionLockedFilters = ({
  source,
  importedIds,
}: {
  source: HistoryImportSource;
  importedIds: readonly string[];
}): Filter[] => {
  if (importedIds.length === 0) {
    return [];
  }

  const isRequest = source === HistoryImportSource.Request;
  const countLabel = `${importedIds.length} already imported`;

  return [
    {
      id: `exclude-imported-${source}`,
      field: isRequest ? REQUEST_ID_FIELD : TRACE_ID_FIELD,
      type: FilterValueType.String,
      operator: "not_in",
      value: [...importedIds],
      valueDisplay: countLabel,
      multiValueDisplay: importedIds.map(String),
    },
  ];
};
